<template>
    <div>
        <Card>
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <transition name="fade">
                <Row v-if="forwardDeliveryTable.sarchCardShow"
                    :gutter="16">
                    <Col span="24">
                    <search-card :form="forwardDeliveryTable.searchForm"
                        :table-load-event="getForwardList"
                        :table-search="forwardDeliveryTable.tableSearch" />
                    </Col>
                </Row>
            </transition>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">预发货单</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="forwardDeliveryTable.sarchCardShow = !forwardDeliveryTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="forwardDeliveryTable.columns"
                    :data="forwardDeliveryTable.rows"
                    :loading="forwardDeliveryTable.loading"
                    :table-search="forwardDeliveryTable.tableSearch"
                    :table-load-event="getForwardList" />
                </Col>
            </Row>

            <Modal v-model="promotionModal.show"
                title="优惠信息"
                width="900">
                <Row :gutter="16"
                    class="row-margin-top-15">
                    <Col span="24">
                    <Table :columns="promotionModal.table.columns"
                        size="small"
                        :data="promotionModal.table.rows"
                        highlight-row
                        stripe
                        border />
                    </Col>
                </Row>
            </Modal>

            <Modal v-model="forwardDetailModal.show"
                title="预发货单详情"
                width="60">
                <Row :gutter="16"
                    class="row-margin-top-15">
                    <Col span="24">
                    <Table :columns="forwardDetailModal.table.columns"
                        size="small"
                        :data="forwardDetailModal.table.rows"
                        highlight-row
                        stripe
                        border />
                    </Col>
                </Row>
            </Modal>

            <Modal v-model="seedFarmConfirmModal.show"
                title="苗场回复">
                <Row :gutter="16">
                    <Col span="24">
                    <RadioGroup v-model="seedFarmConfirmModal.seedFarmResponse">
                        <Radio :label="SEED_FARM_RESPONSE_AGREE">
                            <span>{{ SEED_FARM_RESPONSE_AGREE }}</span>
                        </Radio>
                        <Radio :label="SEED_FARM_RESPONSE_DISAGREE">
                            <span>{{ SEED_FARM_RESPONSE_DISAGREE }}</span>
                        </Radio>
                    </RadioGroup>
                    </Col>
                </Row>

                <div slot="footer">
                    <Button type="primary"
                        @click="onSeedFarmConfirm">确定</Button>
                </div>
            </Modal>
        </Card>
        <PreSaleOrderDetail ref="preSaleOrderDetailModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import { formatDateTimeString } from '@/libs/logic';
import CurrencyInput from '@/components/number-input/currency-input';
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import { dateRender, dateTimeRender } from '@/libs/tableRowTimeRender';
import {
    COMPENSATION_STATUS_NO,
    COMPENSATION_STATUS_YES,
    CUSTOMER_DEDUCTION_STATUS_TYPE_NO,
    CUSTOMER_DEDUCTION_STATUS_TYPE_YES,
    CUSTOMER_RESPONSE_TYPE_UN,
    DELIVERY_STATUS_NO,
    RESULT_TYPE_CUSTOMER_BREAK,
    RESULT_TYPE_SEED_FARM_BREAK,
    RESULT_TYPE_UN,
    SEED_FARM_RESPONSE_AGREE,
    SEED_FARM_RESPONSE_DISAGREE,
    SEED_FARM_RESPONSE_UN
} from '@/view/preSale-management/preSale-order/PreSaleForwardDeliveryStatus';

import {
    getPreSaleForwardDeliveryDetail,
    seedFarmSetResponse,
    transToDelivery,
    withdrawForwardDelivery,
    getPreSaleOrderRelateForwardDelivery
} from '@/api/modules/preSale-management/preSale-order';
import { computePromotion } from '@/api/modules/system-management/seedFarm-management';
import { ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID } from '@/view/preSale-management/preSale-order/PreSaleOrderStatus';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import PreSaleOrderDetail from '@/view/preSale-management/preSale-order/preSale-order-detail';
export default {
    name: 'PreSaleForwardDeliveryList',
    components: {
        CurrencyInput,
        DecimalInput,
        IntegerInput,
        StandPaginationTable,
        SearchCard,
        PreSaleOrderDetail
    },
    data() {
        return {
            show: false,
            innerSpin: false,
            orderUuid: '',
            SEED_FARM_RESPONSE_AGREE,
            SEED_FARM_RESPONSE_DISAGREE,
            COMPENSATION_STATUS_YES,
            CUSTOMER_DEDUCTION_STATUS_TYPE_YES,
            pageLoading: false,
            compensateModal: {
                show: false,
                submitLoading: false,
                form: {
                    orderRecordUuid: '',
                    compensate: 0,
                    remark: ''
                }
            },
            forwardDeliveryTable: {
                columns: [
                    { title: '预发货单号', key: 'preSaleForwardDeliveryRecordCode', width: 180, align: 'center' },
                    {
                        title: '预售单号', key: 'preSaleOrderRecordCode', width: 150, align: 'center',
                        render: (h, params) => {
                            return h('a', {
                                on: {
                                    click: () => {
                                        this.$refs.preSaleOrderDetailModal.showModal(params.row.preSaleOrderRecordUuid);
                                    }
                                }
                            }, params.row.preSaleOrderRecordCode);
                        }
                    },
                    { title: '会员名称', key: 'userPersonName', align: 'center' },
                    { title: '定单合计', key: 'preSaleOrderRecordTotalOrderCost', align: 'center' },
                    { title: '确认金额', key: 'preSaleForwardDeliveryRecordTotalCost', align: 'center' },
                    { title: '已付定金', key: 'preSaleOrderRecordDepositPaymentSum', align: 'center' },
                    { title: '制单时间', key: 'preSaleForwardDeliveryRecordCreateAt', width: 120, align: 'center', render: (h, params) => dateTimeRender(h, params.row.preSaleForwardDeliveryRecordCreateAt) },
                    { title: '送货时间', key: 'preSaleForwardDeliveryRecordDeliveryDate', align: 'center', render: (h, params) => dateRender(h, params.row.preSaleForwardDeliveryRecordDeliveryDate) },
                    { title: '客户反馈', key: 'preSaleForwardDeliveryRecordCustomerResponse', align: 'center' },
                    { title: '苗场反馈', key: 'preSaleForwardDeliveryRecordSeedFarmResponse', align: 'center' },
                    // { title: '结果', key: 'preSaleForwardDeliveryRecordResult', align: 'center' },
                    { title: '备注', key: 'preSaleForwardDeliveryRecordRemark', align: 'left', width: 200 },
                    { title: '发货状态', key: 'preSaleForwardDeliveryRecordDeliveryStatus', align: 'center' },
                    {
                        title: '操作',
                        align: 'center',
                        width: 130,
                        fixed: 'center',
                        render: (h, params) => {
                            const btns = [];

                            const detailBtnElement = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.showForwardDetail(params.row);
                                    }
                                }
                            }, '查看');
                            btns.push(detailBtnElement);

                            // 优惠信息查看，是为了方便苗场确认预发货前使用的，业务流程改了后，做预发货时已计算了优惠。此处的功能，已无意义。
                            // const promotionBtnElement = h('Button', {
                            //     props: {
                            //         type: 'text',
                            //         size: 'small'
                            //     },
                            //     on: {
                            //         click: () => {
                            //             this.showPromotionInfo(params.row);
                            //         }
                            //     }
                            // }, '优惠信息');
                            // btns.push(promotionBtnElement);

                            if (params.row.preSaleForwardDeliveryRecordCustomerResponse !== CUSTOMER_RESPONSE_TYPE_UN
                                && params.row.preSaleForwardDeliveryRecordSeedFarmResponse === SEED_FARM_RESPONSE_UN) {
                                const seedFarmConfirmBtnElement = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {
                                        marginLeft: '4px'
                                    },
                                    on: {
                                        click: () => {
                                            this.seedFarmConfirm(params.row);
                                        }
                                    }
                                }, '苗场确认');

                                btns.push(seedFarmConfirmBtnElement);
                            }

                            if (params.row.preSaleForwardDeliveryRecordResult !== RESULT_TYPE_UN
                                && params.row.preSaleForwardDeliveryRecordDeliveryStatus === DELIVERY_STATUS_NO) {
                                const withdrawBtnElement = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {
                                        marginLeft: '4px'
                                    },
                                    on: {
                                        click: () => {
                                            this.withdraw(params.row);
                                        }
                                    }
                                }, '撤销');
                                btns.push(withdrawBtnElement);

                                const deliveryBtnElement = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {
                                        marginLeft: '4px'
                                    },
                                    on: {
                                        click: () => {
                                            this.delivery(params.row);
                                        }
                                    }
                                }, '发货');

                                btns.push(deliveryBtnElement);
                            }

                            return h('ButtonGroup', btns);
                        }
                    }
                ],
                rows: [],
                loading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '预发货单号', type: 'Input', value: '', name: 'preSaleForwardDeliveryRecordCode', sql: 'like' },
                    { label: '预售单号', type: 'Input', value: '', name: 'preSaleOrderRecordCode', sql: 'like' },
                    { label: '会员名称', type: 'Input', value: '', name: 'concat(userName,userPersonName)', sql: 'like' },
                    { label: '制单时间', type: 'Daterange', value: '', name: 'preSaleForwardDeliveryRecordCreateAt', sql: 'dateBetween' }
                ]
            },
            forwardDetailModal: {
                show: false,
                forwardRecordUuid: '',
                preSaleForwardDeliveryRecordCustomerResponse: '',
                table: {
                    columns: [
                        { title: '产品编号', key: 'preSaleOrderDetailProductCode', align: 'center' },
                        { title: '产品名称', key: 'preSaleOrderDetailProductName', align: 'center' },
                        { title: '单位', key: 'preSaleOrderDetailProductUnit', align: 'center' },
                        { title: '批次号', key: 'preSaleForwardDeliveryDetailBatchCode', align: 'center' },
                        { title: '定单量', key: 'preSaleOrderDetailOrderQuantity', align: 'center' },
                        { title: '预发货量', key: 'preSaleForwardDeliveryDetailQuantity', align: 'center' },
                        {
                            title: '客户确认量',
                            key: 'preSaleForwardDeliveryDetailCustomerConfirmQuantity',
                            align: 'center',
                            render: (h, params) => {
                                const text = this.forwardDetailModal.preSaleForwardDeliveryRecordCustomerResponse === CUSTOMER_RESPONSE_TYPE_UN ? '-' : params.row.preSaleForwardDeliveryDetailCustomerConfirmQuantity;
                                return h('span', {}, text);
                            }
                        },
                        { title: '确认价格', key: 'preSaleForwardDeliveryDetailActProductPrice', align: 'center' },
                        { title: '确认金额', key: 'preSaleForwardDeliveryDetailActProductCost', align: 'center' },
                        { title: '优惠明细', key: 'preSaleForwardDeliveryDetailPromotionInfo', align: 'left', width: 300 }
                    ],
                    rows: []
                }
            },
            promotionModal: {
                show: false,
                table: {
                    columns: [
                        { title: '产品信息', key: 'productInfo', width: 120, align: 'center' },
                        { title: '原价', key: 'oldPrice', width: 80, align: 'center' },
                        { title: '苗场数量满减', key: 'orderQuantityDiscount', width: 80, align: 'center' },
                        { title: '苗场预定优惠', key: 'bookingDayDiscount', width: 80, align: 'center' },
                        { title: '订购量满减', key: 'quanityDiscount', width: 80, align: 'center' },
                        { title: '金额满减', key: 'valueDiscount', width: 80, align: 'center' },
                        { title: '付定金满减', key: 'depositDiscount', width: 80, align: 'center' },
                        { title: '优惠后价格', key: 'newPrice', width: 80, align: 'center' },
                        { title: '优惠明细', key: 'promotionInfo', align: 'center' }
                    ],
                    rows: []
                }
            },
            seedFarmConfirmModal: {
                show: false,
                forwardRecordUuid: '',
                seedFarmResponse: ''
            }
        };
    },
    props: {
        userType: { type: String, default: '' }
    },
    computed: {
    },
    mounted() {
        this.getForwardList();
    },
    methods: {
        formatDateTimeString,
        getForwardList() {

            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.forwardDeliveryTable.tableSearch, "userType");
                this.forwardDeliveryTable.tableSearch.filters.enable = true;
                this.forwardDeliveryTable.tableSearch.filters.conditions.push({
                    name: 'userType',
                    type: 'eq',
                    value: this.userType
                });
            }

            this.forwardDeliveryTable.loading = true;
            getPreSaleOrderRelateForwardDelivery(this.forwardDeliveryTable.tableSearch).then(res => {
                this.forwardDeliveryTable.loading = false;
                if (res.code === 0) {
                    this.forwardDeliveryTable.rows = res.data.records;
                    search.globalSetFilterRecordCount(this.forwardDeliveryTable.tableSearch, res.data.filterRecordCount);
                }
            });
        },
        showPromotionInfo(row) {
            this.forwardDeliveryTable.loading = true;
            computePromotion({ preSaleForwardDeliveryRecordUuid: row.preSaleForwardDeliveryRecordUuid }).then(res => {
                this.forwardDeliveryTable.loading = false;
                if (res.code === 0) {
                    this.promotionModal.table.rows = res.data.promotionInfo;
                    this.promotionModal.show = true;
                }
            });
        },
        showForwardDetail(row) {
            this.innerSpin = true;
            this.forwardDetailModal.forwardRecordUuid = row.preSaleForwardDeliveryRecordUuid;
            this.forwardDetailModal.preSaleForwardDeliveryRecordCustomerResponse = row.preSaleForwardDeliveryRecordCustomerResponse;
            getPreSaleForwardDeliveryDetail(this.forwardDetailModal.forwardRecordUuid).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.forwardDetailModal.table.rows = res.data;
                    let totalOrderQuantity = 0;
                    let totalForwardQuantity = 0;
                    let totalConfirmQuantity = 0;
                    let totalConfirmValue = 0;
                    this.forwardDetailModal.table.rows.forEach(e => {
                        totalOrderQuantity += e.preSaleOrderDetailOrderQuantity;
                        totalForwardQuantity += e.preSaleForwardDeliveryDetailQuantity;
                        totalConfirmQuantity += e.preSaleForwardDeliveryDetailCustomerConfirmQuantity;
                        totalConfirmValue += e.preSaleForwardDeliveryDetailActProductCost;
                    });
                    this.forwardDetailModal.table.rows.push({
                        preSaleForwardDeliveryDetailBatchCode: '合计:',
                        preSaleOrderDetailOrderQuantity: totalOrderQuantity,
                        preSaleForwardDeliveryDetailQuantity: totalForwardQuantity,
                        preSaleForwardDeliveryDetailCustomerConfirmQuantity: totalConfirmQuantity,
                        preSaleForwardDeliveryDetailActProductCost: totalConfirmValue
                    });
                    this.forwardDetailModal.show = true;
                }
            });
        },
        seedFarmConfirm(row) {
            this.seedFarmConfirmModal.forwardRecordUuid = row.preSaleForwardDeliveryRecordUuid;
            this.seedFarmConfirmModal.seedFarmResponse = '';
            this.seedFarmConfirmModal.show = true;
        },
        //撤销预发货单
        withdraw(row) {
            this.$Modal.confirm({
                title: '确认撤回该预发货单',
                onOk: () => {
                    this.innerSpin = true;
                    withdrawForwardDelivery({ preSaleForwardDeliveryRecordUuid: row.preSaleForwardDeliveryRecordUuid }).then(res => {
                        this.innerSpin = false;
                        if (res.code === 0) {
                            this.$Message.success('撤回成功');
                            this.getForwardList();
                        }
                        this.mainTable.tableLoading = false;
                    });
                }
            });
        },
        //发货
        delivery(row) {
            const submitData = {
                preSaleForwardDeliveryRecordUuid: row.preSaleForwardDeliveryRecordUuid
            };
            this.innerSpin = true;
            transToDelivery(submitData).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    const billCode = res.data.billCode;
                    this.$Modal.success({
                        title: '发货成功',
                        content: '发货单号：' + billCode,
                        onOk: () => {
                            this.getForwardList();
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        onSeedFarmConfirm() {
            if (this.seedFarmConfirmModal.seedFarmResponse !== SEED_FARM_RESPONSE_AGREE
                && this.seedFarmConfirmModal.seedFarmResponse !== SEED_FARM_RESPONSE_DISAGREE) {
                this.$Modal.error({ title: '出错啦', content: '苗场回复错误' });
                return;
            }

            const submitData = {
                preSaleForwardDeliveryRecordUuid: this.seedFarmConfirmModal.forwardRecordUuid,
                preSaleForwardDeliveryRecordSeedFarmResponse: this.seedFarmConfirmModal.seedFarmResponse
            };

            this.innerSpin = true;
            seedFarmSetResponse(submitData).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.seedFarmConfirmModal.show = false;

                    this.$Modal.success({
                        title: '回复成功',
                        content: '',
                        onOk: () => {
                            this.getForwardList();
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
